// extracted by mini-css-extract-plugin
module.exports = {"Menu":"TabsMenu_Menu__3my4J","Tab":"TabsMenu_Tab__2F9_H","SelectTab":"TabsMenu_SelectTab__21KXJ","TabsMenu":"TabsMenu_TabsMenu__1GynZ","Disable":"TabsMenu_Disable__1Cp5B"};